import { BlueprintInstanceType } from '../../shared.enums';
import { Island } from '../../islands/island.class';

export const getConnectedIslands = (island: Island, islands:Array<Island> = []) => {
	// Skip if island is null or not actually an Island
	if (!island || island.instanceOf !== BlueprintInstanceType.Island) return islands;

	islands.push(island);
	island.connections.children
		.filter((c) => !c.isSource)
		.forEach((c) => {
			// Only recurse if targetIsland exists and is an Island (not an Obstruction)
			if (c.targetIsland && c.targetIsland.instanceOf === BlueprintInstanceType.Island) {
				getConnectedIslands(c.targetIsland as Island, islands);
			}
		});

	return islands;
};
